export interface ModelDetailedResult720Payload {
  selfAssessPersonRepresentativeId?: number;
  blockBalanceManual?: number;
  blockAverageManual?: number;
  blockType?: string;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  return String(value);
}

export function buildModelDetailedResult720Payload(input: any): ModelDetailedResult720Payload {
  const payload: ModelDetailedResult720Payload = {};

  const selfAssessPersonRepresentativeId = toNumber(input?.selfAssessPersonRepresentativeId);
  if (selfAssessPersonRepresentativeId !== undefined) {
    payload.selfAssessPersonRepresentativeId = selfAssessPersonRepresentativeId;
  }

  const blockBalanceManual = toNumber(input?.blockBalanceManual);
  if (blockBalanceManual !== undefined) {
    payload.blockBalanceManual = blockBalanceManual;
  }

  const blockAverageManual = toNumber(input?.blockAverageManual);
  if (blockAverageManual !== undefined) {
    payload.blockAverageManual = blockAverageManual;
  }

  const blockType = toStringValue(input?.blockType);
  if (blockType !== undefined) {
    payload.blockType = blockType;
  }

  return payload;
}
